<template>
    
  <section :class="pageCss">
    

    <div
      :style="'background-image: url('+heroImage+')'"
      :class="{ 'page__background': true, 'page__background--preload' : heroImageBlur, 'overlay-full': true }"
    ></div>

    <section class="page__intro">

      <div class="wrapper">

        <div>

          <div class="wrapper__inner--intro">


            <h3>{{ content.title }}</h3>
            <h1>{{ content.maintitle }}</h1>
            <p>&nbsp;</p>

          </div>

        </div>

      </div>

      <!-- <div class="overlay__default"><span></span><span></span></div> -->

    </section>

    <img v-images-loaded:on.done="heroImageLoaded" :src="content.heroImage.loaded" class="hero-preload">

    <div id="navbar" class="page__navigation">

      <div class="wrapper">

        <div>

          <div class="wrapper__inner">

            <div class="navigation__links">

              <div>
                <span class="icon-ccw rotate--ccw" @click="closeReadingAndNavigateToPage('page/1')"></span>
              </div>
              <div>
                &nbsp;
              </div>
              <div>
                <span class="icon-twitter" @click="shareContent('twitter', 'Default Share Title', false)"></span>
                <span class="icon-facebook" @click="shareContent('facebook', 'Default Share Title', false)"></span>
                <span class="icon-linkedin" @click="shareContent('linkedin', 'Default Share Title', false)"></span>    

              </div>

            </div>


          </div>

        </div>

      </div>

    </div>


  </section>

</template>

<script>
  import TweenLite from 'gsap';
  import imagesLoaded from 'vue-images-loaded'
  
  // mixins
  import ShareContent from '@/mixins/shareContent';
  import NavigatePages from '@/mixins/navigatePages';
  import HeroImageLoaded from '@/mixins/heroImageLoaded';

  export default {
    name: 'BackCover',
    directives: {
      imagesLoaded
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    metaInfo() {
      return {
        title: this.content.meta.title,
        meta: [
          { name: 'description', content: this.content.meta.description },
          { property: 'og:type', content: this.content.meta.og.type },
          { property: 'og:title', content: this.content.meta.og.title },
          { property: 'og:description', content: this.content.meta.og.description },
          { property: 'og:image', content: this.content.meta.og.image },
          { name: 'twitter:card', content: this.content.meta.twitter.card },
          { name: 'twitter:title', content: this.content.meta.twitter.title },
          { name: 'twitter:description', content: this.content.meta.twitter.description },
          { name: 'twitter:site', content: this.content.meta.twitter.site },
          { name: 'twitter:creator', content: this.content.meta.twitter.creator },
          { name: 'twitter:image', content: this.content.meta.twitter.image }
        ]
      }
    },
    data() {
      return {
        heroImage: this.content.heroImage.preload,
        heroImageBlur: true
      }
    },
    mixins: [ ShareContent, NavigatePages, HeroImageLoaded ],
    computed: {
      pageCss() {
        return `page ${this.content.cssClass}`;
      }
    },
    mounted() {

      // animate the navbar into view
      // eslint-disable-next-line
      TweenLite.to('#navbar', 0.5, { y: 0, delay: 0.5, ease: Power2.easeOut });

    }
  };
</script>